import React from "react";

const partners = [
    { name: "RGU", logo: "/images/rgu.jpeg" },
    { name: "Apollo", logo: "/images/appolo.jpeg" },
];

const Partners: React.FC = () => {
    return (
        <section className="w-full bg-gradient-to-b from-[#201647] to-[#A574BFCC] text-white py-16">

            {/* Title */}
            <h2 className="text-3xl font-light text-center mb-10 px-5">
                Our Partners
            </h2>

            {/* Horizontal Logo Scroll */}
            <div className="overflow-x-auto no-scrollbar">
                <div className="flex gap-4 px-5 snap-x snap-mandatory items-center justify-center  snap-center">

                    {partners.map((p, i) => (
                        <div
                            key={i}
                            className=" bg-white rounded-4xl flex items-center justify-center snap-center"
                        >
                            <img
                                src={p.logo}
                                alt={p.name}
                                className="max-h-32 object-contain"
                            />
                        </div>
                    ))}

                </div>
            </div>

            {/* Text */}
            <div className="px-5 mt-10 space-y-6 text-center">
                <p className="text-base leading-relaxed text-white/80">
                    RGU Motorsport works with industry partners who support our mission to design,
                    build, and race competitive student cars.
                </p>

                <p className="text-base leading-relaxed text-white/80">
                    These collaborations give our team real-world experience and help us push
                    engineering innovation forward.
                </p>
            </div>

            {/* CTA */}
            <div className="mt-10 flex justify-center">
                <a
                    href="mailto:rgu-motorsport@rguunion.co.uk"
                    className="px-6 py-3 border border-white/30 rounded-xl text-sm uppercase tracking-widest hover:bg-white hover:text-black transition"
                >
                    Contact Us
                </a>
            </div>

        </section>
    );
};

export default Partners;